import {default as setup_lokalizacja} from './lokalizacja';
import {default as setup_wyszukaj_mieszkanie} from './wyszukaj-mieszkanie';
import {default as setup_porownywarka} from './porownywarka';

export default function () {
    setup_lokalizacja();
    setup_wyszukaj_mieszkanie();
    setup_porownywarka();
}
